<script>
import {Output} from "@/models/output";
import {computed, inject, ref} from "vue";

export default {
  name: 'VariableFinderOutput',
  template: '#variable-finder-output-template',
  props: {
    output: {type: Output, required: true},
  },
  emits: ['use'],
  setup(props) {
    const isOutputUsed = inject('isOutputUsed');
    const outputFilter = inject('outputFilter');
    const expanded = ref(false);
    const toggle = () => expanded.value = !expanded.value;
    const transformOutput = (func, output) => {
      return new Output({...output, _transform: func});
    }

    return {
      used: isOutputUsed(props.output),
      toggle,
      expanded,
      transformOutput,
      filteredSubOutputs: computed(() => props.output.subOutputs.filter(outputFilter))
    }
  }
}
</script>
